/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Finance_Invoices_TitleInputs */

const en_finance_invoices_title = /** @type {(inputs: Finance_Invoices_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoices`)
};

const pl_finance_invoices_title = /** @type {(inputs: Finance_Invoices_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faktury`)
};

/**
* | output |
* | --- |
* | "Invoices" |
*
* @param {Finance_Invoices_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const finance_invoices_title = /** @type {((inputs?: Finance_Invoices_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finance_Invoices_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_finance_invoices_title(inputs)
	return en_finance_invoices_title(inputs)
});